import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { StandService } from '../proxy/planning/controllers/stand.service';
import { RegisterService } from '../proxy/planning/controllers/register.service';
import { PropertyService } from '../proxy/planning/controllers/property.service';

FieldBuilder.setNamespace('Planning');

export const STANDPERREGISTER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('standRegisterArea', 'Entity.StandPerRegister.StandRegisterArea')
    .required()
    .decimal(4,10)
    .build(),
  FieldBuilder
    .number('standAreaPercentage', 'Entity.StandPerRegister.StandAreaPercentage')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .number('registerAreaPercentage', 'Entity.StandPerRegister.RegisterAreaPercentage')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .checkbox('isMainRegister', 'Entity.StandPerRegister.IsMainRegister')
    .build(),
  FieldBuilder
    .checkbox('isLastRegister', 'Entity.StandPerRegister.IsLastRegister')
    .build(),
  FieldBuilder
    .checkbox('isStandPerRegisterAvailableInGis', 'Entity.StandPerRegister.IsStandPerRegisterAvailableInGis')
    .build(),
  FieldBuilder
    .foreignKey('standId', 'Entity.Stand', StandService)
    .required()
    .displayFromNested('stand.name')
    .sortBy('stand.name')
    .build(),
  FieldBuilder
    .foreignKey('registerId', 'Entity.Register', RegisterService)
    .required()
    .displayFromNested('register.name')
    .sortBy('register.name')
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
];

export const STANDPERREGISTER_CONFIG = {
  entityName: 'StandPerRegister',
  localizationKey: 'Planning::Entity.StandPerRegister',
  fields: STANDPERREGISTER_FIELDS,
  permission: 'PlanningLocation.StandPerRegisters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
